import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchSession } from '@/domains/auth/api/session/session.api';

export const sessionKeys = createQueryKeys('session', {
  details: () => ({
    queryKey: ['session'],
    queryFn: fetchSession,
  }),
});
